import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Localization Components
import { RouterComponent } from './router/router.component';
import { RouterDetailComponent } from './router/detail/router-detail.component';
import { ControlPointerComponent } from './shared/control-pointer/control-pointer.component';
import { HandlerRouterComponent } from './handler-router/handler-router.component';
import { TravelHistoryComponent } from './travel-history/travel-history.component';
import { TravelHistorySummaryComponent } from './travel-history/travel-history-summary/travel-history-summary.component';
import { DevicesComponent } from './devices/devices.component';
import { ModalAddDevicesComponent } from './modal-add-devices/modal-add-devices.component';

const LocalizationComponents = [
  RouterComponent,
  RouterDetailComponent,
  ControlPointerComponent,
  HandlerRouterComponent,
  TravelHistoryComponent,
  TravelHistorySummaryComponent,
  DevicesComponent,
  ModalAddDevicesComponent
];

@NgModule({
  declarations: LocalizationComponents,
  imports: [SharedModule],
  exports: LocalizationComponents
})
export class LocalizationModule { }
